export const RESET = 'EXCMUSERDATASTATUS_LIST_RESET'
export const SET_ITEMS = 'EXCMUSERDATASTATUS_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMUSERDATASTATUS_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMUSERDATASTATUS_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMUSERDATASTATUS_LIST_TOGGLE_LOADING'
